// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"17656fd7","703":"dd222d96"}[chunkId] + ".chunk.js";
};